import React, { useContext, useState } from 'react';
import Reviews from '../profile/Review';
import Breadcrumb from '../../shared/Breadcrumb';
import { AuthContext } from '../../../contexts/AuthContext';
import SideNav from '../shared/SideNav';

const DoctorReview = () => {
    const { userState } = useContext(AuthContext);
    const [doctor, setDoctor] = useState(userState.loggedInUser);

    return (  
        <div>
            <Breadcrumb title="Reviews" />
            <div className="content">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor = 'doctorreview' user={doctor}/>
						</div>
						<div className="col-md-7 col-lg-8 col-xl-9">
							<Reviews doctor={doctor} /> 					
                        </div>
					</div>
				</div>
			</div>		
        </div>
    );
}
 
export default DoctorReview;